import {
  normalizeChannelPlatformCode,
  resolveOnlineStoreChannelCode,
  OnlineStoreChannelLike,
} from './lazada-integration.util';

/** Canonical Shopee channel subtype / platform code in OMS. */
export const SHOPEE_CHANNEL_CODE = 'SHOPEE';

export function isShopeeChannelCode(code: string | undefined | null): boolean {
  return normalizeChannelPlatformCode(code) === SHOPEE_CHANNEL_CODE;
}

export function isShopeeOnlineStore(
  row: OnlineStoreChannelLike | undefined | null,
): boolean {
  return isShopeeChannelCode(resolveOnlineStoreChannelCode(row));
}
